<template>
  <div class="">
    <div class="mgb80">
      <div class="content-web">
        <div class="inner_content_right">
          <div class="wp_single wp_column_article">
            <div class="wp_entry">
              <div class="wp_articlecontent">
                <div class="head">
                  <div class="lsd">天津利顺德大厦有限公司</div>
                  <p class="p1">
                    中外合作企业的利顺德大厦是天津高端四星级涉外国际公寓酒店之一，地处天津政治、金融、文化及中央商务区的核心地带，近代津门历史文化及商业地标近在咫尺，既可以体验小白楼商业区的繁华与便利，又能充分感受百年历史风情的泰安道五大院英式商务风情区的宁静，面朝景色旖旎的海河，毗邻滨江道中心商业区和被誉为“万国建筑”的五大道，感受这个城市从古至今的发展底蕴，动中取静。
                  </p>
                  <div class="img1">
                    <img
                      src="@/assets/images/lsdds1.jpg"
                      alt=""
                      height="450px"
                    />
                  </div>
                  <p class="p2">
                    利顺德大厦多年来一直秉承现代企业管理理念，并在2000年成为天津市首家完成了ISO9000质量管理体系和ISO14000环境管理体系双认证的酒店，同时也是天津旅游行业首家国家级“精神文明单位”。通过多年来市场的锤炼，积累了良好的市场口碑。
                  </p>
                  <div class="img1">
                    <img
                      src="@/assets/images/lsdds2.jpg"
                      alt=""
                      height="450px"
                    />
                  </div>
                  <p class="p2">
                    拥有标准间、套房及豪华套房共84间（套），每个房间均配有电磁炉、冰箱、餐具等，与一楼日本料理餐厅相呼应，满足短期出差、家庭度假、商务长住等各种生活需要。房间布局呈欧式风格，精心装饰配以现代的便利设施。房间可观赏到天津的母亲河——海河全景或欣赏到英式维多利亚花园美景。宽敞舒适的客房设计，配以优质房间设施，为商旅人士提供温馨体验。
                  </p>

                  <p class="p2">
                    与“华夏第一店”——天津利顺德大饭店相连通，免费共享健身中心等五星级酒店设施，使您在享受特惠价格的同时可以享受到五星级的高端服务和设施。
                  </p>
                  <div class="lsd">组织架构</div>
                  <div class="img1">
                    <img
                      src="@/assets/images/lsdds3.png"
                      alt=""
                      height="600px"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {},
};
</script>
<style lang='scss' scoped>
.mgb80 {
  margin-bottom: 80px;
  margin-top: 30px;
  .content-web {
    display: flex;
    width: 100%;
    // min-width: 1200px;
    margin: 0 auto;
    .inner_content_right {
      // float: right;
      //   box-sizing: border-box;
      //   width: 960px;
      //   min-height: 600px;
      //   margin-left: 20px;
      //   background-color: #fff;
      .wp_single.wp_column_article {
        padding: 48px 40px 100px 40px;
      }
      .wp_entry {
        line-height: 2em !important;
        font-size: 14px !important;
        font-family: "宋体" !important;
        width: 100%;
        line-height: 1.7em;
        font-size: 13px;
        color: #333;
        overflow: hidden;;
        .head {
          border-bottom: 1px #444 dashed;
          height: 100%;
          .lsd {
            font-size: 20px;
            text-align: center;
            font-weight: 800;
            margin-bottom: 20px;
          }
          .p1 {
            text-indent: 35px;
            margin-bottom: 20px;
          }
          .p2 {
            text-indent: 35px;
            margin-bottom: 20px;
          }
          .img1 {
            text-align: center;
            margin-bottom: 20px;
          }
        }
      }
      .text {
        text-indent: 35px;
      }
      .ltd {
        float: right;
      }
    }
  }
}
</style>